import CircularProgress from '@material-ui/core/CircularProgress';
import GetAppIcon from '@material-ui/icons/GetApp';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import ReplayIcon from '@material-ui/icons/Replay';
import { useHistory, useLocation } from 'react-router-dom';
import ContactForm from '../../../../../PageResultat/ContactForm';
import { Breadcrumbs, RedesignLayout, useSharedStyles } from '../../../../shared';
import RedesignImage from '../../../../shared/components/RedesignImage';
import {
  getStaffResultBackPath,
  isStaffViewer,
  readBeneficiaryId,
} from '../../../shared/adminResultNav';
import { openMyResultRetake } from '../../../MyResults/openMyResultRetake';
import { MajorTestResultLayoutProps } from '../types';
import GoFurtherSection from './GoFurtherSection';
import HistoryDropdown from './HistoryDropdown';
import { useMajorTestResultLayoutStyles } from './MajorTestResultLayout.styles';

const MajorTestResultLayout = ({
  config,
  loading,
  resultId,
  backPath,
  historyItems,
  onDownloadPdf,
  preparingPdf = false,
  onContactClick,
  openContactForm,
  onContactFormClose,
  children,
  pdfElement,
  resultUserId,
}: MajorTestResultLayoutProps) => {
  const classes = useMajorTestResultLayoutStyles();
  const sharedClasses = useSharedStyles();
  const history = useHistory();
  const location = useLocation();
  const staffViewer = isStaffViewer();
  const beneficiaryId = readBeneficiaryId(location, resultUserId);

  const handleBack = () => {
    history.push(getStaffResultBackPath(location, beneficiaryId));
  };

  return (
    <RedesignLayout isaddBackground={true} noPadding={true} isClassic={true} footer={true}>
      {loading ? (
        <div className={sharedClasses.loadingCenter}>
          <CircularProgress />
        </div>
      ) : (
        <div className={classes.page}>
          <div className={classes.heroBand}>
            <div className={classes.heroTopRow}>
              <div className={classes.heroMain}>
                {staffViewer ? (
                  <button type="button" className={classes.backButton} onClick={handleBack}>
                    ← Retour
                  </button>
                ) : (
                  <Breadcrumbs
                    items={[
                      { label: 'Accueil', href: '/' },
                      { label: 'Mes résultats', href: '/mes-resultats' },
                      { label: config.breadcrumbLabel },
                    ]}
                  />
                )}
                <h1 className={classes.pageTitle}>{config.title}</h1>
                <p className={classes.pageDescription}>{config.description}</p>
                <div className={classes.heroActions}>
                  <button
                    type="button"
                    className={classes.downloadButton}
                    onClick={onDownloadPdf}
                    disabled={preparingPdf}
                    aria-busy={preparingPdf}>
                    {preparingPdf
                      ? 'Préparation du PDF…'
                      : 'Télécharger la restitution au format PDF'}
                    <GetAppIcon className={classes.downloadIcon} />
                  </button>
                  {!staffViewer && (
                    <button
                      type="button"
                      className={classes.retakeButton}
                      onClick={() =>
                        openMyResultRetake(
                          { category: 'major', retakePath: config.retakePath },
                          history.push
                        )
                      }>
                      <ReplayIcon className={classes.retakeIcon} />
                      Refaire le test
                    </button>
                  )}
                </div>
              </div>

              <div className={classes.heroSide}>
                {config.heroImage && (
                  <div className={classes.heroImageWrapper}>
                    <RedesignImage
                      priority={true}
                      src={config.heroImage}
                      alt="Illustration résultats de test"
                      className={classes.heroImage}
                    />
                  </div>
                )}
                <div className={classes.heroHistory}>
                  <HistoryDropdown
                    testResults={historyItems}
                    currentResultId={resultId}
                    redirectPath={config.historyRedirectPath}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={classes.content}>
            {children}
            <GoFurtherSection config={config.goFurther} onContactClick={onContactClick} />
          </div>

          {pdfElement && <div className={classes.hiddenPdf}>{pdfElement}</div>}
        </div>
      )}

      <ContactForm
        test={config.contactFormTest}
        open={openContactForm}
        handleClose={onContactFormClose}
      />
    </RedesignLayout>
  );
};

export default MajorTestResultLayout;
